import React from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import './ErrorPage.css'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

function ErrorPage() {
    const history = useHistory()

    return (
        <div className="errorPage container d-flex justify-content-between flex-wrap text-center">
            <img className="errorPageImg" src="/assets/svg/404.svg" />
            <div className="errorPageActions w-100">
                <h2>{'Not found 404'}</h2>
                <h4>
                    {'We couldnt find the page you are looking for'} <br />
                    {'You can still try exploring hundreds of other product'}
                </h4>
                <PrimaryButton
                    id="search_for_products"
                    label={'Search for products'}
                    onClick={() => handleRedirectInternal(history, '')}
                />
            </div>
        </div>
    )
}

export default ErrorPage
